module.exports = __webpack_public_path__ + "img/people.73f41156.svg";